<template>
  <div>
    <b-navbar toggleable="lg">
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar toggleable>
        <b-navbar-brand>
          <div class="logo">
            <img src="../assets/logo1.png" />
          </div>
        </b-navbar-brand>
      </b-navbar>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-nav>
            <b-nav-item>
              <span class="nav-links" @click="healthCheck"
                >API Health Check</span
              >
            </b-nav-item>
            <b-nav-item>
              <span class="nav-links" @click="goBack">Admin section</span>
            </b-nav-item>
            <b-nav-item>
              <span class="nav-links" href="javascript:void(0)" @click="Logout"
                >Sign out</span
              >
            </b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-container>
      <div>
        <b-form-row class="justify-content-md-center">
          <b-col lg="6" md="12" sm="12">
            <label class="floating-label">Notification type</label>
            <select
              class="form-control"
              id="allNotification"
              :class="{
                'is-value-exist': notificationdata || allNotification,
              }"
              @input="
                notificationdata.notificationSetting = $event.target.value
              "
              v-model="notificationdata.notificationSetting"
              @change="onAllNotificationChange"
            >
              <option
                v-for="(option, index) in options"
                :value="option.value"
                :key="index"
              >
                {{ option.text }}
              </option>
            </select>
          </b-col>
        </b-form-row>
        <b-form-row class="justify-content-md-center">
          <b-col
            lg="3"
            md="6"
            sm="6"
            class="info-save-btn col-6 mt-3 ml-1 p-0 btn-green"
          >
            <b-button block variant="primary" @click="postAllNotificationData"
              >Save</b-button
            >
          </b-col>
          <b-col lg="3" md="6" sm="6" class="col-6 mt-3 btn-white">
            <b-button block variant="primary">Cancel</b-button>
          </b-col>
        </b-form-row>
      </div>
    </b-container>

    <img alt="footer" width="100%" src="../assets/footer.png" />
    <v-idle @idle="onidle" :loop="true" :wait="5" :duration="IDLETIMEOUT" />
  </div>
</template>
<script>
import LogoSvg from "../assets/logo.svg";
import { mapState, mapGetters, mapActions } from "vuex";
import router from "../router";
import { HTTP } from "../helpers/http-common";
import { APIURLS } from "../helpers/apiUrls";
import { IDLETIMEOUT } from "../helpers/constants";

export default {
  name: "Allnotification",
  components: {
    LogoSvg,
  },
  data() {
    return {
      options: [
        // { text: "Notification type", value: "", isDisabled: true, index: 0 },
        { text: "None", value: 0, isDisabled: false, index: 1 },
        { text: "MyKitchener Only", value: 1, isDisabled: false, index: 2 },
        {
          text: "MyKitchener + Email (Immediate)",
          value: 2,
          isDisabled: false,
          index: 3,
        },
        {
          text: "MyKitchener + Email (Daily Summary)",
          value: 3,
          isDisabled: false,
          index: 4,
        },
      ],
      allNotification: null,
      notificationdata: null,

      currentItems: [],

      lr_display: "none",
      IDLETIMEOUT: IDLETIMEOUT,
    };
  },

  methods: {
    getAllNotificationData() {
      HTTP.get(`${APIURLS.getAllNotificationData}`)

        .then((response) => {
          this.notificationdata = response.data;
          return response;
        })
        .catch((error) => {
          // alert(error.response.data.Message);
        });
    },
    postAllNotificationData() {
      const data = {
        id: this.notificationdata.id,
        notificationSetting: this.notificationdata.notificationSetting,
      };
      HTTP.post(`${APIURLS.postAllNotificationData}`, data)

        .then((response) => {
          alert("Updated Successfully");
        })
        .catch((error) => {
          alert(error.response.data.Message);
        });
    },

    goBack() {
      router.push("/admin");
    },
    onAllNotificationChange(value) {
      this.allNotification = value;
    },
    healthCheck() {
      router.push("/healthcheck");
    },
    Logout() {
      this.$store.dispatch("login/logout");
    },
    onidle() {
      this.$store.dispatch("login/logout");
    },
  },

  mounted() {
    this.getAllNotificationData();
    this.$store.dispatch("login/refreshToken");
  },
};
</script>
<style scoped lang="scss">
.goback {
  font-size: 25px;
  cursor: pointer;
}
.goback:hover {
  text-decoration: underline;
}
.login-container {
  background: #fff;
  border: 1px solid #fff;
  border-radius: 14px;
  background-color: white;
  // box-shadow: 0px 3px 5px 3px #aaaaaa;
  // padding: 51px;
}
.logo {
  img {
    width: 40%;
  }
}
.th {
  text-align: left !important;
  // border: inset !important ;
}
table {
  width: 100%;
  // border: 1px solid #ccc;
}

td {
  color: #373a3c !important;
}
table.table-transition .flip-list-move {
  transition: transform 1s;
}
.errorstatus {
  color: #d23037;
}
.opened {
  background-color: yellow;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle !important;
  border-top: 1px solid #dee2e6;
  font-size: 15px;
  text-align: initial;
}
.table thead th {
  border-bottom: 3px solid #6e6e6e !important;
}
.btn-link {
  font-weight: 600;
  color: #d23037;
  text-decoration: none;
}
.v-idle {
  display: none;
}
.btn-green {
  button {
    font-size: 16px;
    color: #fff;
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:hover {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:focus,
  button.focus {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button:not(:disabled):not(.disabled):active:focus {
    background-color: #004d44;
    box-shadow: unset;
    border: none;
    padding: 12px 10px;
  }
  button.disabled,
  button:disabled {
    background-color: #f0f0f0;
    color: black;
  }
}
.btn-white {
  button {
    font-size: 16px;
    color: #000;
    background-color: #fff;
    box-shadow: unset;
    border: 1px solid #cccccc;
    padding: 12px 10px;
  }
  button:hover {
    background-color: #fff;
    color: #000;
    border: 1px solid #cccccc;
    box-shadow: unset;
    padding: 12px 10px;
  }
  button:focus,
  button.focus {
    background-color: #fff;
    box-shadow: unset;
    color: #000;
    border: 1px solid #cccccc;
    padding: 12px 10px;
  }
  button:not(:disabled):not(.disabled):active:focus {
    background-color: #fff;
    color: #000;
    box-shadow: unset;
    border: 1px solid #cccccc;
    padding: 12px 10px;
  }
  button.disabled,
  button:disabled {
    color: #000;
    background-color: #fff;
    border: 1px solid #cccccc;
  }
}
.button:hover,
.form-row button:focus,
a[role="button"]:hover {
  border-color: #c6c6c6;
  outline: 0;
  box-shadow: 1px 1px 5px 1px #ccc;
}
</style>